import React from 'react';
import './MobileMenuToggle.css';

function MobileMenuToggle({ onToggle }) {
  return (
    <button className="mobile-menu-toggle" onClick={onToggle} aria-label="Toggle menu">
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
}

export default MobileMenuToggle;
